import { pick } from 'lodash'

const pickValues =
  <K extends string, L>(keys: readonly K[]) =>
  (list: Partial<Record<K, L>>): L[] =>
    Object.values(pick(list, keys))

export default pickValues
